function LinearKeyframe(to, options) {
  return {
    kind: "linear",
    to,
    duration: options.duration,
    timingCurve: options.timingCurve
  };
}
function SpringKeyframe(to) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return {
    kind: "spring",
    to,
    ...options
  };
}
function CubicKeyframe(to, options) {
  return {
    kind: "cubic",
    to,
    ...options
  };
}
function MoveKeyframe(to) {
  return {
    kind: "move",
    to
  };
}
function KeyframeTrack(keyPath, content) {
  if (typeof keyPath === "string") return {
    kind: "track",
    keyPath,
    content: content !== null && content !== void 0 ? content : []
  };
  return {
    kind: "track",
    content: keyPath
  };
}
export {
  CubicKeyframe,
  KeyframeTrack,
  LinearKeyframe,
  MoveKeyframe,
  SpringKeyframe
};
//# sourceMappingURL=keyframes.js.map
